<template>
    <div class="codics-factory-admin-user-body">
        <div class="codics-factory-admin-user-control">
            <el-input class="codics-factory-admin-user-control-input" style="width: 300px !important;"
                placeholder="请输入账号/昵称/邮箱/手机号..." v-model="searchTxt" clearable @input="searchChange">
                <el-button style="padding: 0 20px 0 20px;" slot="append" icon="el-icon-search"
                    @click="searchPage = 1; searchMax = 0; searchData = []; searchUsersFuc();"></el-button>
            </el-input>
            <!-- <el-popconfirm :title="'您确定要重置当前选中的' + selectData.length + '个账号密码为123456吗？'" @confirm="rePassFuc">
                <el-button class="codics-factory-admin-user-control-search" slot="reference" type="warning"
                    icon="el-icon-key" plain>重置密码</el-button>
            </el-popconfirm> -->
            <el-popconfirm :title="'您确定要删除当前选中的' + selectData.length + '条数据吗？'" @confirm="deleteUsersFuc">
                <el-button class="codics-factory-admin-user-control-search" slot="reference" type="danger"
                    icon="el-icon-delete" plain>批量删除</el-button>
            </el-popconfirm>
            <el-button class="codics-factory-admin-user-control-search"
                style="float: right !important;margin-right: 0 !important;" icon="el-icon-download"
                @click="tableToExcel" plain>导出数据</el-button>
        </div>
        <el-table stripe class="codics-factory-admin-user-table" :data="searchTxt == '' ? tableData : searchData" border
            style="width: 100%" @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="40">
            </el-table-column>
            <el-table-column prop="id" label="ID" width="80">
            </el-table-column>
            <el-table-column prop="himg" label="头像" width="60">
                <template slot-scope="scope">
                    <el-image style="top:3.5px"
                        :src="scope.row.himg == null ? 'https://cdn.bosscaigou.com/huayuan/img/yasuo_60bc7e65a6d385d503656e12772d226.webp' : ('https://cdn.bosscaigou.com/' + scope.row.himg)"
                        fit="fill">
                        <div slot="error" class="image-slot">
                            <i class="el-icon-picture-outline"></i>
                        </div>
                    </el-image>
                </template>
            </el-table-column>
            <el-table-column prop="nickname" label="昵称" width="180">
            </el-table-column>
            <el-table-column prop="points.points" label="积分" width="280">
                <template slot-scope="scope">
                    {{ scope.row.points.points }}
                    <el-popover placement="top" width="180px" v-model="scope.row.rowVisible">
                        <el-input-number v-model="scope.row.nowPoints" style="display: block !important;" :min="-999999"
                            :max="999999" label="描述文字"></el-input-number>
                        <el-input v-model="scope.row.bzTxt" placeholder="请输入积分增减备注"
                            style="width: 180px !important;display: block !important;margin-top: 10px;"></el-input>
                        <el-button type="success" plain style="display: block !important;width: 180px;margin-top: 10px;"
                            @click="handlePointsChange(scope)">确认增减</el-button>
                        <el-button size="mini" slot="reference" type="info" style="float: right !important;"
                            @click.stop="scope.row.nowPoints = 0;">增减积分</el-button>
                    </el-popover>
                    <!-- <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button> -->
                    <!-- <el-popconfirm title="这是一段内容确定删除吗？" @confirm="deleteUsersFuc([scope.row.id])">
                        <el-button style="float: right !important;margin-right: 10px;" size="mini"
                            slot="reference">查询记录</el-button>
                    </el-popconfirm> -->
                </template>
            </el-table-column>
            <el-table-column align="right" label="操作" min-width="150">
                <template slot-scope="scope">
                    <el-popconfirm title="这是一段内容确定删除吗？" @confirm="deleteUsersFuc([scope.row.id])">
                        <el-button size="mini" type="danger" slot="reference">初始化</el-button>
                    </el-popconfirm>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination class="codics-factory-admin-user-table-page" @size-change="handleSizeChange"
            @current-change="handleCurrentChange" :current-page="searchTxt == '' ? currentPage : searchPage"
            :page-sizes="[10, 20, 30, 40]" :page-size="10" layout="total, sizes, prev, pager, next, jumper"
            :total="searchTxt == '' ? maxSize : searchMax">
        </el-pagination>
    </div>
</template>

<script>
import { getUserList, rePass, searchUsers3, deleteUsers, updateUserPoints } from '@/api';
import { exportExcel } from '@/utils/myutils';
export default {
    data() {
        return {
            currentPage: 1,
            searchPage: 1,
            searchTxt: '',
            tableData: [],
            searchData: [],
            multipleSelection: [],
            maxSize: 0,
            searchMax: 0,
            dataSize: 10,
            searchSize: 10,
            selectData: [],
            nowSearchTxt: ''
        }
    },
    mounted() {
        this.listUsersFuc();
    },
    methods: {
        async handlePointsChange(s) {

            if (s.row.bzTxt == null || s.row.bzTxt == '') {

                this.$message({
                    message: '积分修改备注不能为空！',
                    type: 'warning'
                });

                return;

            }

            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            let data = await updateUserPoints({ u: s.row.id, p: s.row.nowPoints, s: s.row.points.state, t: s.row.bzTxt });
            loading.close();
            if (data.code == 200) {
                this.$message({
                    message: '积分数据修改成功！',
                    type: 'success'
                });
                setTimeout(() => {
                    window.location.reload();
                }, 300);
            } else {
                this.$message.error(data.message);
            }

        },
        handleSelectionChange(val) {
            this.selectData = val;
        },
        async rePassFuc(t) {

            if (t == null) {

                if (this.selectData.length == 0) {

                    this.$message({
                        showClose: true,
                        message: '请先选中要重置的数据！',
                        type: 'warning'
                    });

                    return true;

                }

                var t = [];

                this.selectData.forEach(item => {

                    t[t.length] = item.id;

                });

            }

            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });

            let data = await rePass({ ids: t });

            loading.close();

            if (data.code == 200) {

                this.$message({
                    message: data.data + '条数据重置成功！',
                    type: 'success'
                });

                setTimeout(() => {

                    window.location.reload();

                }, 300);

            } else {

                this.$message.error(data.message);

            }

        },
        async deleteUsersFuc(t) {

            if (t == null) {

                if (this.selectData.length == 0) {

                    this.$message({
                        showClose: true,
                        message: '请先选中要删除的数据！',
                        type: 'warning'
                    });

                    return true;

                }

                var t = [];

                this.selectData.forEach(item => {

                    t[t.length] = item.id;

                });

            }

            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });

            let data = await deleteUsers({ ids: t });

            loading.close();

            if (data.code == 200) {

                this.$message({
                    message: data.data + '条数据删除成功！',
                    type: 'success'
                });

                setTimeout(() => {

                    window.location.reload();

                }, 300);

            } else {

                this.$message.error(data.message);

            }

        },
        async searchUsersFuc() {

            if (this.searchTxt == '') {

                this.$message.error('请先输入要搜索的内容！');

                return;

            }

            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            let data = await searchUsers3({ key: this.searchTxt, pge: this.searchPage, psz: this.searchSize });
            loading.close();
            if (data.code == 200) {
                this.searchData = data.data;
                this.searchMax = data.count;
            } else {
                this.$message.error(data.message);
            }

        },
        async listUsersFuc(state) {

            if (state && this.searchTxt == '') {

                this.$message({
                    showClose: true,
                    message: '搜索内容不能为空！',
                    type: 'warning'
                });

                return true;

            }

            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });

            let data = await searchUsers3({ key: this.nowSearchTxt, pge: this.searchTxt == '' ? this.currentPage : this.searchPage, psz: this.searchTxt == '' ? this.dataSize : this.searchSize });

            loading.close();

            if (data.code == 200) {

                if (this.searchTxt == '') {

                    this.tableData = data.data;
                    this.maxSize = data.count;

                } else {

                    this.searchData = data.data;
                    this.searchMax = data.count;

                }

            } else {

                this.$message.error(data.message);

            }

        },
        async getUserListData(pge, psz) {

            let data = await getUserList({ 'pge': pge, 'psz': psz });

            if (data.code == 200) {

                this.tableData = data.data;

                this.maxSize = data.count;

            } else {

                this.$message.error(data.message);

            }

        },
        handleSizeChange(val) {
            if (this.searchTxt == '') {
                this.dataSize = val;
                this.listUsersFuc();
            } else {
                this.searchSize = val;
                this.listUsersFuc();
            }
        },
        handleCurrentChange(val) {
            if (this.searchTxt == '') {
                this.currentPage = val;
                this.listUsersFuc();
            } else {
                this.searchPage = val;
                this.listUsersFuc();
            }
        },
        sexFilter(v, r, c) {

            return r.sex === v;

        },
        memberFilter(v, r, c) {

            return r.member === v;

        },
        stateFilter(v, r, c) {

            return r.state === v;

        },
        wxFilter(v, r, c) {

            let t = r.wxkey === null || r.wxkey === '';

            return v == 0 ? !t : t;

        },
        qqFilter(v, r, c) {

            let t = r.qkey === null || r.qkey === '';

            return v == 0 ? !t : t;

        },
        async resetPass(idx, row) {

            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            let data = await rePass({ id: row.id });
            loading.close();
            if (data.code == 200) {
                this.$message({
                    message: '账号密码重置成功！',
                    type: 'success'
                });
            } else {
                this.$message.error(data.message);
            }

        },
        searchChange(a) {
            if (a == '') {
                this.searchPage = 1;
                this.searchData = [];
                this.searchMax = 0;
                this.searchSize = 10;
                this.nowSearchTxt = '';
            }
        }
    }
}
</script>

<style>
/* 后台管理端主页 */
.codics-factory-admin-user-body {
    height: 100%;
    width: 100%;
    min-height: 100%;
    position: relative;
    float: left;
    background: #FFF;
    box-sizing: border-box;
    padding: 20px;
    overflow-y: scroll;
}

/* 后台管理页面主页 */
.codics-factory-admin-user-control {
    height: fit-content;
    width: 100%;
    position: relative;
    float: left;
}

/* 后台管理页面主页控制栏 */
.codics-factory-admin-user-control-input {
    width: 300px !important;
    position: relative;
    float: left;
    margin-right: 20px;
    margin-bottom: 20px;
}

/* 后台管理页面控制栏搜索按钮 */
.codics-factory-admin-user-control-search {
    position: relative;
    float: left;
    margin-left: 0px !important;
    margin-right: 20px !important;
}

/* 表格控件 */
.codics-factory-admin-user-table {
    height: fit-content;
    width: 100% !important;
    position: relative;
    float: left;
    margin-bottom: 20px;
}

/* 表格分页控件 */
.codics-factory-admin-user-table-page {
    position: relative;
    float: right;
    right: 0;
}

.codics-factory-admin-user-table .el-table__cell {
    padding: 8px 0 !important;
}
</style>